<section id="inicio" class="main">
    <div class="spotlight m-2 p-2">
        <!-- <div class="container"> -->
        <div id="carouselExampleControls" class="carousel slide" data-ride="carousel">
            <div class="carousel-inner">
                <div class="carousel-item active">
                    <img class="d-block w-100" src="/assets/images/2023.jpg" alt="First slide" />
                </div>
            </div>
        </div>
        <!-- </div> -->
    </div>
</section>

<!-- <div class="container">
    <hr style="height: 3px; border: none; color: #345f55; background-color: #345f55" />
</div> -->

<section class="row">
    <div class="bg-white">
        <div class="container-fluid p-5">
            <div class="row">
                <div class="col-12 col-md-12 text-center">
                    <div class="">
                        <h2>ELECCIÓN CONSECUTIVA</h2>
                        <p style="color: #000;  text-align: justify;">
                            <!-- Es la posibilidad jurídica para que un ciudadano que haya desempeñado algún cargo de elección
                        popular ocupe nuevamente éste al finalizar el periodo de su ejercicio, sin la necesidad de que
                        exista un periodo intermedio donde no se ejerza el puesto. -->

                            De conformidad con el Artículo 6 de los Lineamientos sobre Elección Consecutiva para
                            Senadurías y Diputaciones Federales por ambos principios, para el Proceso Electoral Federal
                            2023-2024, las diputadas y los diputados que pretendan
                            elegirse de manera consecutiva deberán notificar su decisión al INE, a través de la
                            Dirección Ejecutiva de Prerrogativas y Partidos Políticos, 
                            a la presidencia del partido político respectivo y a la
                            <b>
                            Cámara de Diputados
                        
                            
                            del 
                            Honorable Congreso de la Unión, a través de su Presidencia y Secretaría General.
                    </b>
                             
                            Para ello,
                            presentarán ante dichas instancias una carta de intención a más tardar un día antes
                            del inicio de las precampañas electorales federales.
                    </p>
                    </div>
                </div>
                <div class="col-12 col-md-12 text-center">
                    <div class="alert alert-success">
                        <h4>
                            La fecha y hora límite para la recepción de las Cartas de Intención que corresponden a la Cámara de Diputados,
                             será a las 23:59 h del día
                            19 de noviembre del 2023; de conformidad con el Artículo 6 de los Lineamientos sobre
                            Elección Consecutiva para Senadurías y Diputaciones Federales por ambos principios, para el
                            Proceso Electoral Federal 2023-2024.
                        </h4>
                    </div>
                </div>
                <!-- <div class="col-lg-3"></div> -->
                <div class="col-lg-12">
                    <div class="alert alert-info" style="text-align: right;">

                        <!-- Nota. Se recomienda a las y los diputados que las cartas de intención, se dirijan a la
                        Presidencia de la Mesa Directiva con copia para la Secretaría General y se entreguen oportunamente en
                        ambas instancias.
                        <br>
                        <br> -->
<b>
                        La entrega de la carta de intención a las autoridades de la Cámara no exime de la entrega de la documentación correspondiente al Instituto Nacional Electoral (INE) y a las presidencias de los partidos políticos.
                    </b>
                    </div>
                </div>
                <div class="col-lg-12">
                    <p class="alert alert-primary text-center">
                        <b>
                            Aviso <br>
                            Las oficinas de la Presidencia de la Mesa Directiva y la Secretaría General estarán abiertas el 
                            sábado 18 de noviembre de 10:00 a 14:00 hrs y el
                            domingo 19 de noviembre
                            de 10:00 a 23:59 horas
                        </b>
                    </p>
                </div>
            </div>

            <div class="items-container">
                <hr />
            </div>

            <div class="row">
                <div class="col-md-6 mx-auto">
                    <a [routerLink]="['/diputados']">
                        <div class="service-item text-center">
                            <div class="services-icon">
                                <!-- <i class="tf-ion-android-calendar"></i> -->
                                <img src="assets/images/por_reeleccion.png" width="50px" height="50px" />
                            </div>
                            <h4 class="service-title">Información relevante</h4>
                            <p class="service-description">
                                Diputados y Diputadas a Elección Consecutiva 2023-2024.
                            </p>
                        </div>
                    </a>
                </div>
            </div>

            <div class="items-container">
                <hr />
            </div>

            <div class="row">
                <div *ngIf="listadoDocumentosAcuerdos">
                    <div class="col-12 separadorFondo text-center">
                        <h2 class="formatoSeparador responsiveEncabezadosHome">
                            DOCUMENTOS y ACUERDOS
                        </h2>
                    </div>
                    <div class="">
                        <div class="row justify-content-center">
                            <div class="col-lg-3  text-center" *ngFor="let aviso of listadoDocumentosAcuerdos">
                                <mat-card class="example-card m-1">
                                    <mat-card-header>
                                        <div mat-card-avatar class="example-header-image"></div>
                                        <mat-card-title>{{ aviso.Nombre }}</mat-card-title>

                                    </mat-card-header>

                                    <img mat-card-image *ngIf="aviso.UrlImagen" class="img-fluid"
                                        src="{{ aviso.UrlImagen }}" alt="{{ aviso.Nombre }}" />
                                    <mat-card-content  class="d-none d-sm-block">
                                        <p style="text-align: center">{{ aviso.Descripcion }}</p>
                                    </mat-card-content>
                                    <mat-card-actions class="center" style="
align-content: center !important;
text-align: center !important;
">
                                        <a *ngIf="aviso.UrlArchivo" [href]="aviso.UrlArchivo" target="_blank"> <button
                                                style="background-color: #183c34; color: white" mat-button>
                                                Descargar
                                            </button></a>
                                    </mat-card-actions>
                                </mat-card>
                            </div>
                        </div>

                    </div>
                </div>
            </div>
        </div>
    </div>
</section>

<!--  -->

<!-- Programa -->
<!-- <section class="tabla" id="agenda">
    <div class="container">
        <div class="row">
            <div class="col-md-12 text-center">
                <h2>
                    DIPUTADAS Y DIPUTADOS POR REELECCIÓN CONSECUTIVA
                </h2>
                <h4>
                    Lorem ipsum dolor sit amet, consectetur adipisicing elit. Pariatur, commodi ad quibusdam saepe, impedit eveniet nesciunt dolorem recusandae voluptas similique sed maxime mollitia sint! Odio sed velit nisi fugiat tenetur.
                </h4>
                <br />
            </div>
        </div>

        <div class="row m-12" style="align-items: center; text-align: center;">
            <div class="col-md-3"></div>
            <div class="col-md-6 center">
                <a [routerLink]="['/renuncias']">
                    <div class="service-item text-center">
                        <div class="services-icon">
                            <i class="tf-ion-android-calendar"></i>
                        </div>
                        <h4 class="service-title">Información reelevante</h4>
                        <p class="service-description">
                            Diputados y Diputadas a Elección Consecutiva 2021.
                        </p>
                    </div>
                </a>
                            </div>
                            <div class="col-md- 3"></div>


                        </div>
                    </div>
</section> -->